(function(){
  if(window.__plFun)return;window.__plFun=true;
  function mq(q){return window.matchMedia&&matchMedia(q).matches}
  var reduce=mq('(prefers-reduced-motion: reduce)');
  var fine=mq('(hover: hover) and (pointer: fine)');
  function ready(fn){if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fn)}else{fn()}}
  function rnd(a,b){return a+Math.random()*(b-a)}

  ready(function(){
    /* Scroll progress bar */
    var pb=document.createElement('div');pb.className='plf-progress';
    var pi=document.createElement('i');pb.appendChild(pi);document.body.appendChild(pb);
    function prog(){var h=document.documentElement,m=h.scrollHeight-h.clientHeight;pi.style.transform='scaleX('+(m>0?Math.min(1,h.scrollTop/m):0)+')'}
    window.addEventListener('scroll',prog,{passive:true});window.addEventListener('resize',prog);prog();
    if(reduce)return;

    /* Helpers */
    function burst(x,y,set,n){
      set=set||['\uD83D\uDC3E','\uD83C\uDF89','\u2B50','\uD83D\uDC96','\uD83E\uDDB4'];n=n||18;
      for(var i=0;i<n;i++){(function(){
        var c=document.createElement('span');c.className='plf-conf';
        c.textContent=set[Math.floor(Math.random()*set.length)];
        c.style.left=x+'px';c.style.top=y+'px';c.style.fontSize=rnd(16,28)+'px';
        document.body.appendChild(c);
        var a=rnd(0,Math.PI*2),d=rnd(70,190),dx=Math.cos(a)*d,dy=Math.sin(a)*d-50,rot=rnd(-300,300);
        var an=c.animate([
          {transform:'translate(-50%,-50%) scale(.3) rotate(0deg)',opacity:1},
          {transform:'translate(calc(-50% + '+dx+'px),calc(-50% + '+dy+'px)) scale(1) rotate('+rot+'deg)',opacity:1,offset:.7},
          {transform:'translate(calc(-50% + '+(dx*1.1)+'px),calc(-50% + '+(dy+40)+'px)) scale(.8) rotate('+(rot*1.2)+'deg)',opacity:0}
        ],{duration:rnd(900,1400),easing:'cubic-bezier(.1,.7,.3,1)',fill:'forwards'});
        an.onfinish=function(){c.remove()};
      })()}
    }
    function woof(x,y){
      var b=document.createElement('div');b.className='plf-woof';
      b.textContent=['Woof!','Arf!','Bark!','Yip!'][Math.floor(Math.random()*4)];
      b.style.left=x+'px';b.style.top=y+'px';document.body.appendChild(b);
      var a=b.animate([
        {transform:'translate(-50%,-10%) scale(.2)',opacity:0},
        {transform:'translate(-50%,-120%) scale(1.15)',opacity:1,offset:.25},
        {transform:'translate(-50%,-150%) scale(1)',opacity:1,offset:.75},
        {transform:'translate(-50%,-190%) scale(.9)',opacity:0}
      ],{duration:1500,easing:'ease-out'});
      a.onfinish=function(){b.remove()};
    }

    /* Hero: split headline, drifting paws, parallax, logo easter egg */
    var t=document.querySelector('.pl-hero__title');
    if(t&&!t.getAttribute('data-split')){
      var txt=t.textContent.trim();
      t.setAttribute('aria-label',txt);t.setAttribute('data-split','1');t.textContent='';
      var words=txt.split(/\s+/);
      words.forEach(function(w,i){
        var o=document.createElement('span');o.className='plf-w';o.setAttribute('aria-hidden','true');o.style.setProperty('--i',i);
        var inn=document.createElement('span');inn.textContent=w;o.appendChild(inn);t.appendChild(o);
        if(i<words.length-1)t.appendChild(document.createTextNode(' '));
      });
      t.classList.add('plf-split');
    }
    var hero=document.querySelector('.pl-hero');
    if(hero){
      var box=document.createElement('div');box.className='plf-paws';box.setAttribute('aria-hidden','true');
      for(var i=0;i<12;i++){
        var s=document.createElement('span');s.textContent='\uD83D\uDC3E';
        s.style.setProperty('--x',rnd(2,96)+'%');s.style.setProperty('--s',rnd(16,34)+'px');
        s.style.setProperty('--t',rnd(14,26)+'s');s.style.setProperty('--dl',(-rnd(0,24))+'s');
        s.style.setProperty('--r0',rnd(-30,0)+'deg');s.style.setProperty('--r1',rnd(10,50)+'deg');
        box.appendChild(s);
      }
      hero.insertBefore(box,hero.firstChild);
      var vis=hero.querySelector('.pl-hero__visual');
      if(fine&&vis){
        var raf=0;
        hero.addEventListener('mousemove',function(e){
          var r=hero.getBoundingClientRect(),x=((e.clientX-r.left)/r.width-.5)*2,y=((e.clientY-r.top)/r.height-.5)*2;
          cancelAnimationFrame(raf);
          raf=requestAnimationFrame(function(){vis.style.setProperty('--mx',x.toFixed(3));vis.style.setProperty('--my',y.toFixed(3))});
        });
        hero.addEventListener('mouseleave',function(){vis.style.setProperty('--mx',0);vis.style.setProperty('--my',0)});
      }
      var logo=hero.querySelector('.pl-hero__logo');
      if(logo){
        logo.style.cursor='pointer';logo.setAttribute('title','Say hi');
        logo.addEventListener('click',function(){
          var r=logo.getBoundingClientRect();
          woof(r.left+r.width/2,r.top);
          burst(r.left+r.width/2,r.top+r.height/2,['\uD83D\uDC3E','\uD83E\uDDB4','\uD83D\uDC96'],14);
        });
      }
    }

    /* Add to cart: flying paw + confetti + cart bump */
    var lastBtn=null,lastAt=0;
    document.addEventListener('click',function(e){
      var b=e.target.closest('.pl-btn[data-add],.pl-up__add,.product-form__submit,.quick-add__submit,.pl-sticky .pl-btn');
      if(b){lastBtn=b;lastAt=Date.now()}
    },true);
    function fly(){
      if(!lastBtn||Date.now()-lastAt>5000)return;
      var r=lastBtn.getBoundingClientRect(),cart=document.getElementById('cart-icon-bubble');
      var sx=r.left+r.width/2,sy=Math.min(Math.max(r.top+r.height/2,24),window.innerHeight-24);
      burst(sx,sy);
      lastBtn=null;
      if(!cart)return;
      var cr=cart.getBoundingClientRect(),tx=cr.left+cr.width/2,ty=Math.max(cr.top+cr.height/2,24);
      var dx=tx-sx,dy=ty-sy;
      var f=document.createElement('span');f.className='plf-fly';f.textContent='\uD83D\uDC3E';
      f.style.left=sx+'px';f.style.top=sy+'px';document.body.appendChild(f);
      var a=f.animate([
        {transform:'translate(-50%,-50%) scale(1)',opacity:1},
        {transform:'translate(calc(-50% + '+(dx*.45)+'px),calc(-50% + '+(Math.min(dy*.5,-60)-90)+'px)) scale(1.7) rotate(-20deg)',opacity:1,offset:.45},
        {transform:'translate(calc(-50% + '+dx+'px),calc(-50% + '+dy+'px)) scale(.4) rotate(20deg)',opacity:.4}
      ],{duration:950,easing:'cubic-bezier(.45,.05,.55,.95)'});
      a.onfinish=function(){f.remove();cart.classList.remove('plf-bump');void cart.offsetWidth;cart.classList.add('plf-bump')};
    }
    document.addEventListener('pl:cart',fly);
    try{if(typeof subscribe==='function'&&window.PUB_SUB_EVENTS)subscribe(PUB_SUB_EVENTS.cartUpdate,function(){setTimeout(fly,50)})}catch(err){}

    /* Button ripple */
    document.addEventListener('pointerdown',function(e){
      var b=e.target.closest('.pl-btn,.pl-pill');if(!b||b.disabled)return;
      var r=b.getBoundingClientRect(),s=Math.max(r.width,r.height)*.5;
      var d=document.createElement('span');d.className='plf-ripple';
      d.style.width=d.style.height=s+'px';d.style.left=(e.clientX-r.left-s/2)+'px';d.style.top=(e.clientY-r.top-s/2)+'px';
      b.appendChild(d);setTimeout(function(){d.remove()},800);
    });

    /* Deal bar celebration */
    document.querySelectorAll('.pl-up__bar').forEach(function(b){
      var was=b.classList.contains('is-full');
      new MutationObserver(function(){
        var now=b.classList.contains('is-full');
        if(now&&!was){var r=b.getBoundingClientRect();burst(r.left+r.width/2,r.top+r.height/2,['\uD83C\uDF89','\u2B50','\uD83D\uDC3E'],24)}
        was=now;
      }).observe(b,{attributes:true,attributeFilter:['class']});
    });

    /* Footer runner */
    var foot=document.querySelector('.pl-foot');
    if(foot){
      var run=document.createElement('div');run.className='plf-runner';run.setAttribute('aria-hidden','true');
      var sp=document.createElement('span');sp.textContent='\uD83D\uDC15';run.appendChild(sp);foot.appendChild(run);
    }

    /* Mouse-only effects: magnetic buttons, 3D tilt, paw trail */
    if(fine){
      var mag=null;
      document.addEventListener('mousemove',function(e){
        var b=e.target.closest&&e.target.closest('.pl-btn');
        if(mag&&mag!==b){mag.style.translate='';mag=null}
        if(!b)return;
        mag=b;var r=b.getBoundingClientRect();
        b.style.translate=((e.clientX-r.left-r.width/2)*.18)+'px '+((e.clientY-r.top-r.height/2)*.28)+'px';
      });
      document.addEventListener('mouseout',function(e){if(!e.relatedTarget&&mag){mag.style.translate='';mag=null}});

      var tiltSel=[['.card-wrapper','.card__inner'],['.pl-why__card',null],['.pl-up__card',null],['.pl-rev__card',null],['.pl-feat__media',null]];
      var cur=null;
      function clearTilt(){if(cur){cur.classList.remove('plf-on');cur.style.removeProperty('--rx');cur.style.removeProperty('--ry');cur=null}}
      document.addEventListener('mousemove',function(e){
        var host=null,inner=null;
        for(var i=0;i<tiltSel.length;i++){
          var h=e.target.closest&&e.target.closest(tiltSel[i][0]);
          if(h){host=h;inner=tiltSel[i][1]?h.querySelector(tiltSel[i][1]):h;break}
        }
        if(!inner){clearTilt();return}
        if(cur&&cur!==inner)clearTilt();
        cur=inner;inner.classList.add('plf-tilt','plf-on');
        var r=host.getBoundingClientRect(),px=(e.clientX-r.left)/r.width-.5,py=(e.clientY-r.top)/r.height-.5;
        inner.style.setProperty('--ry',(px*9).toFixed(2)+'deg');inner.style.setProperty('--rx',(-py*9).toFixed(2)+'deg');
      });
      document.addEventListener('mouseout',function(e){if(!e.relatedTarget)clearTilt()});

      var lastT=0,flip=1;
      document.addEventListener('mousemove',function(e){
        var n=performance.now();if(n-lastT<130)return;lastT=n;flip*=-1;
        var p=document.createElement('span');p.className='plf-trail';p.textContent='\uD83D\uDC3E';
        p.style.left=(e.clientX+flip*8)+'px';p.style.top=e.clientY+'px';p.style.setProperty('--r',(flip*18+rnd(-10,10))+'deg');
        document.body.appendChild(p);setTimeout(function(){p.remove()},1300);
      });
    }
  });
})();
